/* eslint-disable react/style-prop-object */
import './style.css';

import React from 'react';
import { FormattedNumber, IntlShape } from 'react-intl';
import { getWeekOfMonth } from 'date-fns';

const computeAge = (birthDate: Date, referenceDate?: Date) => {
  if (!birthDate) return null;
  const diff = new Date((referenceDate?.getTime() || Date.now()) - birthDate.getTime());

  if (diff.getTime() < 0) return null;

  return {
    years: diff.getFullYear() - 1970,
    months: diff.getMonth(),
    weeks: getWeekOfMonth(diff),
  };
};

const ageToString = (birthDate: Date, intl: IntlShape, referenceDate?: Date) => {
  const age = computeAge(birthDate, referenceDate);
  if (!age) return '';
  const years =
    age.years > 0
      ? intl.formatNumber(age.years, {
          style: 'unit',
          unit: 'year',
          unitDisplay: 'narrow',
        })
      : '';
  const months =
    age.months > 0
      ? intl.formatNumber(age.months, {
          style: 'unit',
          unit: 'month',
          unitDisplay: 'narrow',
        })
      : '';
  return `${years}${months !== '' ? ' ' : ''}${months}`;
};

type AgeFromDateProps = {
  birthDate: Date;
  referenceDate?: Date;
};

class AgeFromDate extends React.PureComponent<AgeFromDateProps> {
  render = () => {
    const { birthDate, referenceDate } = this.props;
    const age = computeAge(birthDate, referenceDate);
    if (!age) return null;
    return (
      <div className="age-from-date">
        {age.years > 0 ? (
          <div>
            <FormattedNumber style="unit" unit="year" unitDisplay="narrow" value={age.years} />
          </div>
        ) : null}
        {age.months > 0 ? (
          <div>
            <FormattedNumber style="unit" unit="month" unitDisplay="narrow" value={age.months} />
          </div>
        ) : null}
        {birthDate && age.months === 0 && age.years === 0 ? (
          <div>
            {'<'}
            <FormattedNumber style="unit" unit="month" unitDisplay="narrow" value={1} />
          </div>
        ) : null}
      </div>
    );
  };
}

export default AgeFromDate;
export { computeAge, ageToString };
